import React from 'react';
import { canonicalInternalHref } from '../lib/routes';

interface InternalLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  to: string;
  onNavigate?: (path: string) => void;
}

export function InternalLink({
  to,
  onNavigate,
  onClick,
  children,
  ...props
}: InternalLinkProps) {
  const href = canonicalInternalHref(to);
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);

    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      !onNavigate ||
      !href.startsWith('/') ||
      href.startsWith('//') ||
      props.download !== undefined ||
      props.target ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    event.preventDefault();
    onNavigate(href);
  };

  return (
    <a href={href} onClick={handleClick} {...props}>
      {children}
    </a>
  );
}
